import {GET_FLOW} from 'actions/userFlow';

export default (state = null, action) => {
    switch (action.type) {
        case GET_FLOW:
            return action.payload;
    }
    return state;
}
